import React from "react";

export default function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="81"
      viewBox="0 0 68 68"
      fill="none"
    >
      <path
        d="M68 34C68 27.7125 66.2566 21.5482 62.9634 16.1921C59.6703 10.8361 54.9565 6.49804 49.3459 3.66019C43.7353 0.82235 37.4477 -0.404154 31.1818 0.116996C24.916 0.638147 18.9174 2.88654 13.8527 6.61228L34 34H68Z"
        fill="#6061E5"
      />
      <path
        d="M14.6619 6.03509C9.75134 9.43078 5.82153 14.0596 3.26768 19.4561C0.713835 24.8526 -0.374005 30.8264 0.113573 36.7767C0.601152 42.727 2.64696 48.4441 6.04523 53.3528C9.4435 58.2615 14.0744 62.1889 19.4722 64.7399C24.87 67.291 30.8444 68.3757 36.7945 67.885C42.7445 67.3943 48.4605 65.3455 53.3675 61.9446C58.2744 58.5438 62.1994 53.9108 64.7476 48.5117C67.2957 43.1125 68.3773 37.1376 67.8835 31.1878L34 34L14.6619 6.03509Z"
        fill="#73D3CD"
      />
      <path
        d="M15.2565 5.63307C10.0108 9.09922 5.82887 13.9521 3.17561 19.6523C0.522352 25.3525 -0.498332 31.6768 0.226997 37.9223C0.952326 44.1678 3.39526 50.0898 7.28428 55.0302C11.1733 59.9706 16.3561 63.7359 22.2566 65.9076L34 34L15.2565 5.63307Z"
        fill="#F2D1E2"
      />
    </svg>
  );
}
